// src/pages/DoctorDashboard.js
import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Calendar,
  Users,
  Video,
  MessageCircle,
  CheckCircle2,
  Clock,
  Menu,
  X,
  ChevronDown,
  ChevronRight,
  Plus,
  Search,
  Filter,
  Bell,
  LogOut,
  User,
  Settings,
  ArrowLeft,
  FileText,
  Save,
  Mic,
  MicOff,
  VideoOff,
  Check,
  Brain,
  Lightbulb,
  Camera,
  Mail,
  Phone as PhoneIcon,
  Award,
  Shield,
  Trash2,
  ArrowRight,
} from "lucide-react";
import quantumLogo from "../../quantum-care-logo.png";
import doctorimg from "../../doctor.png";
import {
  GetAppointmentDetailsApi,
  GetPatientAppointmentsApi,
} from "../Patient/PatientAPI";
import { FormattedMessage, useIntl } from "react-intl";
import { Context } from "../../CommonComponents/Wrapper";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../CommonComponents/Select";

function DoctorDashboard() {
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [sendToPharmacy, setSendToPharmacy] = useState(true);
  const [sendToPatient, setSendToPatient] = useState(true);
  const doctor = {
    name: "Dr. Emily Chen",
    specialty: "General Practice",
    avatar: doctorimg,
  };
  const [referralList, setReferralList] = useState([
    {
      id: Date.now(),
      specialty: "",
      doctorName: "",
      reason: "",
      urgency: "",
      notes: "",
    },
  ]);
  const [tests, setTests] = useState([
    { id: Date.now(), testName: "", urgency: "", notes: "", category: "" },
  ]);
  const generateRandomPatient = (appointmentId) => {
    const maldivianPatients = [
      {
        name: "Ahmed Hassan",
        cardno: "QCHC1234",
        avatar:
          "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      },
      {
        name: "Aisha Ibrahim",
        cardno: "QCHC1235",
        avatar:
          "https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      },
      {
        name: "Mohamed Ali",
        cardno: "QCHC1236",
        avatar:
          "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      },
      {
        name: "Mariyam Naseer",
        cardno: "QCHC1237",
        avatar:
          "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      },
      {
        name: "Ibrahim Waheed",
        cardno: "QCHC1238",
        avatar:
          "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      },
      {
        name: "Fathimath Riyaz",
        cardno: "QCHC1239",
        avatar:
          "https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      },
      {
        name: "Hassan Mohamed",
        cardno: "QCHC1240",
        avatar:
          "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      },
      {
        name: "Aminath Shauna",
        cardno: "QCHC1241",
        avatar:
          "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      },
      {
        name: "Ali Rameez",
        cardno: "QCHC1242",
        avatar:
          "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      },
      {
        name: "Hawwa Zulfa",
        cardno: "QCHC1243",
        avatar:
          "https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      },
      {
        name: "Ismail Nasheed",
        cardno: "QCHC1244",
        avatar:
          "https://images.unsplash.com/photo-1506277886164-e25aa3f4ef7f?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      },
      {
        name: "Khadija Hussain",
        cardno: "QCHC1245",
        avatar:
          "https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      },
    ];

    // Use appointment ID to ensure consistent patient for same appointment
    const index = parseInt(appointmentId) % maldivianPatients.length;
    return maldivianPatients[index];
  };
  // const allAppointments = [
  //   {
  //     id: "APT-1001",
  //     patient: "Ahmed Hassan",
  //     cardno: "QCHC1234",
  //     avatar:
  //       "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
  //     date: "2025-08-20",
  //     time: "10:00 AM",
  //     type: "video",
  //     status: "upcoming",
  //     notes: "Follow-up for blood pressure",
  //     patientDetails: {
  //       name: "Ahmed Hassan",
  //       age: 29,
  //       sex: "Male",
  //       phone: "+960 123 4567",
  //       email: "ahmed.hassan@example.mv",
  //     },
  //     aiDiagnosis:
  //       "Patient presents with moderate seasonal allergy symptoms including runny nose, sneezing, and watery eyes. Symptoms started 5 days ago and have been progressively worsening. No fever reported. Patient has a history of similar seasonal allergic reactions. Physical examination reveals mild nasal congestion and slightly reddened eyes. Recommended antihistamine treatment.",
  //   },
  //   {
  //     id: "APT-1002",
  //     patient: "Aisha Ibrahim",
  //     cardno: "QCHC1235",
  //     avatar:
  //       "https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
  //     date: "2025-08-18",
  //     time: "02:30 PM",
  //     type: "chat",
  //     status: "upcoming",
  //     notes: "Medication review",
  //     patientDetails: {
  //       name: "Aisha Ibrahim",
  //       age: 34,
  //       sex: "Female",
  //       phone: "+960 987 6543",
  //       email: "aisha.ibrahim@example.mv",
  //     },
  //     aiDiagnosis:
  //       "Patient reports ongoing hypertension management. Current medication regimen appears to be working well with blood pressure readings within normal range. No significant side effects reported.",
  //   },
  //   {
  //     id: "APT-0998",
  //     patient: "Mohamed Ali",
  //     cardno: "QCHC1236",
  //     avatar:
  //       "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
  //     date: "2025-08-12",
  //     time: "11:15 AM",
  //     type: "video",
  //     status: "completed",
  //     notes: "Seasonal allergies",
  //     patientDetails: {
  //       name: "Mohamed Ali",
  //       age: 41,
  //       sex: "Male",
  //       phone: "+960 456 7890",
  //       email: "mohamed.ali@example.mv",
  //     },
  //     aiDiagnosis:
  //       "Patient presented with classic symptoms of seasonal allergies. Treatment with antihistamines was successful. Symptoms have significantly improved.",
  //   },
  //   {
  //     id: "APT-0997",
  //     patient: "Sarah Thomson",
  //     cardno: "QCHC1237",
  //     avatar:
  //       "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
  //     date: "2025-08-11",
  //     time: "09:45 AM",
  //     type: "video",
  //     status: "completed",
  //     notes: "General check-up",
  //     patientDetails: {
  //       name: "Sarah Thomson",
  //       age: 28,
  //       sex: "Female",
  //       phone: "+960 321 0987",
  //       email: "sarah.thomson@example.mv",
  //     },
  //     aiDiagnosis:
  //       "Routine health check-up completed. All vital signs within normal limits. Patient reports good overall health with no concerns.",
  //   },
  // ];

  /* -------------------------------------------------------------------- */
  /*  ⬤  STATE                                                            */
  /* -------------------------------------------------------------------- */
  const [currentPage, setCurrentPage] = useState("home");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [filter, setFilter] = useState("all");
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [doctorNotes2, setDoctorNotes2] = useState("");
  const [prescription, setPrescription] = useState("");
  const [labTests, setLabTests] = useState("");
  const [recommendedTests, setRecommendedTests] = useState([]);
  const [nearestPHC, setNearestPHC] = useState("");
  const { locale, selectLang } = useContext(Context);
  const [language, setLanguage] = useState("en-US");
  const AppointmentDetails = useSelector(
    (state) => state.patient.AppointmentDetails
  );

  // Add referrals state to the main component
  const [referrals, setReferrals] = useState("");

  const [prescriptionRows, setPrescriptionRows] = useState([
    {
      drug: "",
      frequency: "",
      intake: "",
      duration: "",
      instructions: "",
    },
  ]);
  // Video call states
  const [isInWaitingRoom, setIsInWaitingRoom] = useState(false);
  const [isOnVideoCall, setIsOnVideoCall] = useState(false);
  const [callEnded, setCallEnded] = useState(false);

  const allAppointments = useSelector(
    (state) => state.patient.patientAppointments
  );

  const callAppointmentDetails = (appointmentId) => {
    dispatch(GetAppointmentDetailsApi(appointmentId));
  };

  useEffect(() => {
    dispatch(GetPatientAppointmentsApi(1));
  }, []);

  useEffect(() => {
    if (AppointmentDetails != null) {
      setSelectedAppointment(AppointmentDetails);
    }
  }, [AppointmentDetails]);

  // Video call handlers
  const handleJoinVideoCall = () => {
    setIsInWaitingRoom(false);
    setIsOnVideoCall(true);
    setCallEnded(false);
  };

  const handleEndCall = () => {
    setIsOnVideoCall(false);
    setCallEnded(true);
  };

  const handleCallEndedClose = () => {
    setCallEnded(false);
    setCurrentPage("appointments");
  };

  const startVideoCall = (appointment) => {
    //setSelectedAppointment(appointment);
    setIsInWaitingRoom(true);
    callAppointmentDetails(appointment);
  };

  // Add prescription handlers
  const handlePrescriptionFieldChange = (index, field, value) => {
    setPrescriptionRows((prevRows) => {
      const newRows = [...prevRows];
      newRows[index] = { ...newRows[index], [field]: value };
      return newRows;
    });
  };

  const addPrescriptionRow = () => {
    setPrescriptionRows((prev) => [
      ...prev,
      {
        drug: "",
        frequency: "",
        intake: "",
        duration: "",
        instructions: "",
      },
    ]);
  };

  const removePrescriptionRow = (index) => {
    if (prescriptionRows.length > 1) {
      setPrescriptionRows((prev) => prev.filter((_, i) => i !== index));
    }
  };

  useEffect(() => {
    selectLang(language);
  }, [language]);

  /* -------------------------------------------------------------------- */
  /*  ⬤  PRESCRIPTION COMPONENT                                           */
  /* -------------------------------------------------------------------- */
  const SimplePrescriptionTable = ({
    rows,
    onFieldChange,
    onAddRow,
    onRemoveRow,
  }) => {
    // Common drug options
    const drugOptions = [
      "Aspirin 81mg",
      "Ibuprofen 200mg",
      "Acetaminophen 500mg",
      "Amoxicillin 500mg",
      "Metformin 500mg",
    ];

    const frequencyOptions = [
      "Once Daily",
      "Twice Daily",
      "Thrice Daily",
      "Every 6 Hours",
      "Every 8 Hours",
      "Every 12 Hours",
      "As Needed",
    ];

    const intakeOptions = [
      "Before Food",
      "After Food",
      "With Food",
      "Any Time",
    ];

    return (
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Prescription ({rows.length} rows)
        </label>
        <div className="border border-gray-300 rounded-lg overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-left font-medium text-gray-700 border-b">
                  Drug Name
                </th>
                <th className="px-4 py-3 text-left font-medium text-gray-700 border-b">
                  Frequency
                </th>
                <th className="px-4 py-3 text-left font-medium text-gray-700 border-b">
                  Intake
                </th>
                <th className="px-4 py-3 text-left font-medium text-gray-700 border-b">
                  Duration
                </th>
                <th className="px-4 py-3 text-left font-medium text-gray-700 border-b">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, index) => (
                <tr
                  key={`prescription-${index}`}
                  className="border-b border-gray-200 last:border-b-0"
                >
                  {/* Drug Name Select - CHANGED FROM INPUT TO SELECT */}
                  <td className="px-4 py-3">
                    <select
                      value={row.drug || ""} // Ensure string value
                      onChange={(e) =>
                        onFieldChange(index, "drug", e.target.value)
                      }
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent"
                    >
                      <option value="">Select drug name</option>
                      {drugOptions.map((drug) => (
                        <option key={drug} value={drug}>
                          {drug}
                        </option>
                      ))}
                      <option
                        disabled
                        style={{
                          borderTop: "1px dotted #9CA3AF",
                          paddingTop: "4px",
                          marginTop: "4px",
                          color: "#9CA3AF",
                        }}
                      >
                        ────────────────
                      </option>
                      <option
                        value="add-new"
                        style={{
                          fontStyle: "calibri",
                          color: "#059669",
                          fontWeight: "500",
                        }}
                      >
                        ✚ Add New
                      </option>
                    </select>
                  </td>

                  {/* Frequency Select */}
                  <td className="px-4 py-3">
                    <select
                      value={row.frequency || ""}
                      onChange={(e) =>
                        onFieldChange(index, "frequency", e.target.value)
                      }
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent"
                    >
                      <option value="">Select frequency</option>
                      {frequencyOptions.map((opt) => (
                        <option key={opt} value={opt}>
                          {opt}
                        </option>
                      ))}
                    </select>
                  </td>

                  {/* Intake Select */}
                  <td className="px-4 py-3">
                    <select
                      value={row.intake || ""}
                      onChange={(e) =>
                        onFieldChange(index, "intake", e.target.value)
                      }
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent"
                    >
                      <option value="">Select intake</option>
                      {intakeOptions.map((opt) => (
                        <option key={opt} value={opt}>
                          {opt}
                        </option>
                      ))}
                    </select>
                  </td>

                  {/* Duration Input */}
                  <td className="px-4 py-3">
                    <div className="flex items-center">
                      <input
                        type="number"
                        value={row.duration || ""}
                        onChange={(e) =>
                          onFieldChange(index, "duration", e.target.value)
                        }
                        className="w-20 border border-gray-300 rounded-md px-3 py-2 text-sm mr-2 focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent"
                        min="0"
                        placeholder="0"
                      />
                      <span className="text-sm text-gray-600">Day(s)</span>
                    </div>
                  </td>

                  {/* Action Buttons */}
                  <td className="px-4 py-3">
                    <div className="flex items-center space-x-2">
                      {index === 0 ? (
                        <button
                          onClick={onAddRow}
                          type="button"
                          className="inline-flex items-center px-3 py-1 rounded-md bg-green-50 border border-green-200 text-sm text-green-700 hover:bg-green-100 transition-colors"
                        >
                          <Plus className="w-4 h-4 mr-1" />
                          Add
                        </button>
                      ) : (
                        <button
                          onClick={() => onRemoveRow(index)}
                          type="button"
                          className="inline-flex items-center px-3 py-1 rounded-md bg-red-50 border border-red-200 text-sm text-red-700 hover:bg-red-100 transition-colors"
                        >
                          <Trash2 className="w-4 h-4" />
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  // Add at the top of your file (or as a new file)

  const IntegratedDeviceTestSection = ({
    recommendedTests,
    setRecommendedTests,
    nearestPHC,
    setNearestPHC,
  }) => {
    // Sample test options, adjust as required
    const testOptions = [
      "Blood Pressure",
      "Glucose",
      "Cholesterol",
      "ECG",
      "Oxygen Saturation",
    ];

    // Example PHC locations
    const phcOptions = [
      "PHC A - Downtown",
      "PHC B - Riverside",
      "PHC C - Uptown",
    ];

    const handleTestChange = (test) => {
      if (recommendedTests.includes(test)) {
        setRecommendedTests(recommendedTests.filter((t) => t !== test));
      } else {
        setRecommendedTests([...recommendedTests, test]);
      }
    };

    return (
      <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Integrated Device Test Recommendations
        </label>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
          {testOptions.map((test) => (
            <label key={test} className="flex items-center space-x-2">
              <input
                type="checkbox"
                checked={recommendedTests.includes(test)}
                onChange={() => handleTestChange(test)}
                className="form-checkbox h-4 w-4 text-teal-600"
              />
              <span className="text-gray-700 text-sm">{test}</span>
            </label>
          ))}
        </div>

        <label className="block text-sm font-medium text-gray-700 mb-2">
          Nearest Primary Health Center (PHC) for Tests
        </label>
        <select
          value={nearestPHC}
          onChange={(e) => setNearestPHC(e.target.value)}
          className="w-full border border-gray-300 rounded-md px-3 py-2 text-gray-900 text-sm focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent"
        >
          <option value="">-- Select PHC --</option>
          {phcOptions.map((phc) => (
            <option key={phc} value={phc}>
              {phc}
            </option>
          ))}
        </select>
      </div>
    );
  };

  /* -------------------------------------------------------------------- */
  /*  ⬤  LAB TESTS COMPONENT                                              */
  /* -------------------------------------------------------------------- */
  const LabTestsSection = ({ labTests, setLabTests }) => {
    // Lab test categories
    const testCategories = [
      "Blood Tests",
      "Urine Tests",
      "Imaging",
      "Cardiology",
      "Pathology",
      "Microbiology",
      "Biochemistry",
      "Other",
    ];

    // Urgency levels
    const urgencyLevels = ["Routine", "Urgent", "ASAP", "Emergency"];

    // Common lab tests by category
    const commonTests = {
      "Blood Tests": [
        "Complete Blood Count (CBC)",
        "Blood Sugar (Glucose)",
        "Lipid Profile",
        "Liver Function Test (LFT)",
        "Kidney Function Test (KFT)",
        "Thyroid Function Test (TFT)",
        "HbA1c",
        "ESR",
        "CRP",
      ],
      "Urine Tests": [
        "Urine Routine & Microscopy",
        "Urine Culture",
        "24-hour Urine Collection",
        "Protein in Urine",
      ],
      Imaging: [
        "X-Ray Chest",
        "X-Ray Abdomen",
        "Ultrasound Abdomen",
        "CT Scan",
        "MRI",
        "ECG",
        "Echo",
      ],
      Cardiology: ["ECG", "Echocardiogram", "Stress Test", "Holter Monitor"],
      Pathology: ["Biopsy", "Pap Smear", "Fine Needle Aspiration"],
      Microbiology: [
        "Blood Culture",
        "Sputum Culture",
        "Stool Culture",
        "Wound Swab",
      ],
    };
    const updateTestHandler = React.useCallback((id, field, value) => {
      setTests((prev) =>
        prev.map((test) =>
          test.id === id ? { ...test, [field]: value } : test
        )
      );
    }, []);

    const addTestHandler = React.useCallback(() => {
      setTests((prev) => [
        ...prev,
        {
          id: Date.now(),
          testName: "",
          urgency: "",
          notes: "",
          category: "",
        },
      ]);
    }, []);

    const removeTestHandler = React.useCallback(
      (id) => {
        if (tests.length > 1) {
          setTests((prev) => prev.filter((test) => test.id !== id));
        }
      },
      [tests.length]
    );
    const addTest = () => {
      setTests((prev) => [
        ...prev,
        {
          id: Date.now(),
          testName: "",
          urgency: "",
          notes: "",
          category: "",
        },
      ]);
    };

    const removeTest = (id) => {
      if (tests.length > 1) {
        setTests((prev) => prev.filter((test) => test.id !== id));
      }
    };

    const updateTest = (id, field, value) => {
      setTests((prev) =>
        prev.map((test) =>
          test.id === id ? { ...test, [field]: value } : test
        )
      );
    };

    // Generate lab tests text for saving
    React.useEffect(() => {
      const testsText = tests
        .map((test) => {
          const { testName, urgency, notes, category } = test;
          if (!testName) return null;
          return `${testName} (${category}) - ${urgency}${
            notes ? ` - ${notes}` : ""
          }`;
        })
        .filter(Boolean)
        .join("\n");
      setLabTests(testsText);
    }, [tests, setLabTests]);

    return (
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Recommended Lab Tests
        </label>
        <div className="border border-gray-300 rounded-lg overflow-hidden">
          <div className="bg-gradient-to-r from-purple-50 to-indigo-50 px-4 py-3 border-b border-gray-200">
            <div className="flex items-center">
              <div className="w-6 h-6 bg-purple-100 rounded-full flex items-center justify-center mr-3">
                <span className="text-purple-600 text-sm">🧪</span>
              </div>
              <h4 className="text-sm font-semibold text-gray-800">
                Laboratory Investigations
              </h4>
            </div>
          </div>

          <div className="p-4 space-y-4">
            {tests.map((test, index) => (
              <div
                key={test.id}
                className="bg-gray-50 border border-gray-200 rounded-lg p-4"
              >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-3">
                  {/* Category Selection */}
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Test Category
                    </label>
                    <select
                      value={test.category}
                      onChange={(e) =>
                        updateTestHandler(test.id, "category", e.target.value)
                      }
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-transparent"
                    >
                      <option value="">Select category</option>
                      {testCategories.map((category) => (
                        <option key={category} value={category}>
                          {category}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Urgency Level */}
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Urgency Level
                    </label>
                    <select
                      value={test.urgency}
                      onChange={(e) =>
                        updateTestHandler(test.id, "urgency", e.target.value)
                      }
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-transparent"
                    >
                      <option value="">Select urgency</option>
                      {urgencyLevels.map((level) => (
                        <option key={level} value={level}>
                          {level}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Test Name */}
                <div className="mb-3">
                  <label className="block text-xs font-medium text-gray-600 mb-1">
                    Test Name
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="Enter test name or select from suggestions below"
                      value={test.testName}
                      onChange={(e) =>
                        updateTestHandler(test.id, "testName", e.target.value)
                      }
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-transparent"
                    />
                  </div>

                  {/* Quick suggestions based on category */}
                  {test.category && commonTests[test.category] && (
                    <div className="mt-2">
                      <p className="text-xs text-gray-500 mb-1">
                        Common {test.category}:
                      </p>
                      <div className="flex flex-wrap gap-1">
                        {commonTests[test.category]
                          .slice(0, 6)
                          .map((commonTest) => (
                            <button
                              key={commonTest}
                              type="button"
                              onClick={() =>
                                updateTest(test.id, "testName", commonTest)
                              }
                              className="inline-flex items-center px-2 py-1 rounded-md bg-purple-100 text-purple-700 text-xs hover:bg-purple-200 transition-colors"
                            >
                              {commonTest}
                            </button>
                          ))}
                      </div>
                    </div>
                  )}
                </div>

                {/* Clinical Notes */}
                <div className="mb-3">
                  <label className="block text-xs font-medium text-gray-600 mb-1">
                    Clinical Notes (Optional)
                  </label>
                  <textarea
                    rows={2}
                    placeholder="Additional instructions or clinical reasoning..."
                    value={test.notes}
                    onChange={(e) =>
                      updateTestHandler(test.id, "notes", e.target.value)
                    }
                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-transparent resize-none"
                  />
                </div>

                {/* Action Buttons */}
                <div className="flex justify-between items-center pt-2 border-t border-gray-200">
                  <div className="flex items-center text-xs text-gray-500">
                    <span className="w-2 h-2 bg-purple-400 rounded-full mr-2"></span>
                    Test #{index + 1}
                  </div>
                  <div className="flex space-x-2">
                    {index === 0 ? (
                      <button
                        onClick={addTestHandler}
                        type="button"
                        className="inline-flex items-center px-3 py-1 rounded-md bg-green-50 border border-green-200 text-sm text-green-700 hover:bg-green-100 transition-colors"
                      >
                        <Plus className="w-4 h-4 mr-1" />
                        Add Test
                      </button>
                    ) : (
                      <button
                        onClick={() => removeTestHandler(test.id)}
                        type="button"
                        className="inline-flex items-center px-3 py-1 rounded-md bg-red-50 border border-red-200 text-sm text-red-700 hover:bg-red-100 transition-colors"
                      >
                        <Trash2 className="w-4 h-4 mr-1" />
                        Remove
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Quick Add Common Tests */}
          <div className="bg-gray-50 px-4 py-3 border-t border-gray-200">
            <p className="text-xs font-medium text-gray-600 mb-2">
              Quick Add Common Tests:
            </p>
            <div className="flex flex-wrap gap-2">
              {[
                "Complete Blood Count",
                "Blood Sugar",
                "Lipid Profile",
                "Urine R/M",
                "X-Ray Chest",
                "ECG",
              ].map((quickTest) => (
                <button
                  key={quickTest}
                  type="button"
                  onClick={() => {
                    const newTest = {
                      id: Date.now(),
                      testName: quickTest,
                      urgency: "Routine",
                      notes: "",
                      category: quickTest.includes("Blood")
                        ? "Blood Tests"
                        : quickTest.includes("Urine")
                        ? "Urine Tests"
                        : quickTest.includes("X-Ray") ||
                          quickTest.includes("ECG")
                        ? "Imaging"
                        : "Other",
                    };
                    setTests((prev) => [...prev, newTest]);
                  }}
                  className="inline-flex items-center px-2 py-1 rounded-md bg-white border border-gray-300 text-xs text-gray-700 hover:bg-gray-100 transition-colors"
                >
                  + {quickTest}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  /* -------------------------------------------------------------------- */
  /*  ⬤  VIDEO CALL COMPONENTS                                            */
  /* -------------------------------------------------------------------- */

  /* -------------------------------------------------------------------- */
  /*  ⬤  REFERRAL COMPONENT                                               */
  /* -------------------------------------------------------------------- */
  const ReferralSection = ({ referrals, setReferrals }) => {
    // Medical specialties
    const specialties = [
      "Cardiology",
      "Dermatology",
      "Endocrinology",
      "Gastroenterology",
      "Neurology",
      "Oncology",
      "Orthopedics",
      "Psychiatry",
      "Pulmonology",
      "Rheumatology",
      "Urology",
      "Gynecology",
      "Pediatrics",
      "Ophthalmology",
      "ENT (Ear, Nose, Throat)",
      "Nephrology",
      "Hematology",
      "Radiology",
      "Anesthesiology",
      "General Surgery",
    ];

    // Referral urgency levels
    const urgencyLevels = [
      "Routine",
      "Within 2 weeks",
      "Within 1 week",
      "Urgent (within 3 days)",
      "Emergency",
    ];

    // Common referral reasons by specialty
    const commonReasons = {
      Cardiology: [
        "Chest pain evaluation",
        "Hypertension management",
        "Heart murmur assessment",
        "Arrhythmia evaluation",
        "Coronary artery disease",
      ],
      Dermatology: [
        "Skin lesion evaluation",
        "Chronic skin condition",
        "Mole assessment",
        "Acne treatment",
        "Rash investigation",
      ],
      Endocrinology: [
        "Diabetes management",
        "Thyroid disorder",
        "Hormone imbalance",
        "Metabolic syndrome",
        "Weight management",
      ],
      Orthopedics: [
        "Joint pain evaluation",
        "Fracture assessment",
        "Back pain management",
        "Sports injury",
        "Arthritis treatment",
      ],
      Neurology: [
        "Headache evaluation",
        "Seizure assessment",
        "Memory concerns",
        "Tremor evaluation",
        "Numbness/tingling",
      ],
    };

    // Sample specialist doctors
    const specialistDoctors = {
      Cardiology: [
        "Dr. Sarah Ahmed (Cardiologist)",
        "Dr. Mohamed Hassan (Cardiac Surgeon)",
      ],
      Dermatology: [
        "Dr. Aisha Rahman (Dermatologist)",
        "Dr. Ibrahim Ali (Skin Specialist)",
      ],
      Endocrinology: [
        "Dr. Fatima Khan (Endocrinologist)",
        "Dr. Ahmed Naseem (Diabetes Specialist)",
      ],
      Orthopedics: [
        "Dr. Hassan Ibrahim (Orthopedic Surgeon)",
        "Dr. Mariyam Ali (Joint Specialist)",
      ],
      Neurology: [
        "Dr. Ali Hassan (Neurologist)",
        "Dr. Zara Ahmed (Brain Specialist)",
      ],
    };

    const addReferral = () => {
      setReferralList((prev) => [
        ...prev,
        {
          id: Date.now(),
          specialty: "",
          doctorName: "",
          reason: "",
          urgency: "",
          notes: "",
        },
      ]);
    };

    const removeReferral = (id) => {
      if (referralList.length > 1) {
        setReferralList((prev) =>
          prev.filter((referral) => referral.id !== id)
        );
      }
    };

    const updateReferral = (id, field, value) => {
      setReferralList((prev) =>
        prev.map((referral) =>
          referral.id === id ? { ...referral, [field]: value } : referral
        )
      );
    };

    // Generate referrals text for saving
    React.useEffect(() => {
      const referralsText = referralList
        .map((referral) => {
          const { specialty, doctorName, reason, urgency, notes } = referral;
          if (!specialty || !reason) return null;
          return `Refer to ${specialty}${
            doctorName ? ` (${doctorName})` : ""
          } - ${reason} - ${urgency}${notes ? ` - ${notes}` : ""}`;
        })
        .filter(Boolean)
        .join("\n");
      setReferrals(referralsText);
    }, [referralList, setReferrals]);

    return (
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Refer to Specialist (USA Doctor)
        </label>
        <div className="border border-gray-300 rounded-lg overflow-hidden">
          <div className="bg-gradient-to-r from-orange-50 to-amber-50 px-4 py-3 border-b border-gray-200">
            <div className="flex items-center">
              <div className="w-6 h-6 bg-orange-100 rounded-full flex items-center justify-center mr-3">
                <span className="text-orange-600 text-sm">👨‍⚕️</span>
              </div>
              <h4 className="text-sm font-semibold text-gray-800">
                Specialist Referrals
              </h4>
              <span className="ml-2 text-xs text-orange-600 bg-orange-100 px-2 py-1 rounded-full">
                For specialized care
              </span>
            </div>
          </div>

          <div className="p-4 space-y-4">
            {referralList.map((referral, index) => (
              <div
                key={referral.id}
                className="bg-gradient-to-r from-orange-25 to-amber-25 border border-orange-200 rounded-lg p-4"
              >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-3">
                  {/* Specialty Selection */}
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Medical Specialty *
                    </label>
                    <select
                      value={referral.specialty}
                      onChange={(e) =>
                        updateReferral(referral.id, "specialty", e.target.value)
                      }
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-transparent"
                    >
                      <option value="">Select specialty</option>
                      {specialties.map((specialty) => (
                        <option key={specialty} value={specialty}>
                          {specialty}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Urgency Level */}
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Referral Priority *
                    </label>
                    <select
                      value={referral.urgency}
                      onChange={(e) =>
                        updateReferral(referral.id, "urgency", e.target.value)
                      }
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-transparent"
                    >
                      <option value="">Select priority</option>
                      {urgencyLevels.map((level) => (
                        <option key={level} value={level}>
                          {level}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Preferred Doctor */}
                <div className="mb-3">
                  <label className="block text-xs font-medium text-gray-600 mb-1">
                    Preferred Specialist (Optional)
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="Enter specific doctor name or leave blank for any available specialist"
                      value={referral.doctorName}
                      onChange={(e) =>
                        updateReferral(
                          referral.id,
                          "doctorName",
                          e.target.value
                        )
                      }
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-transparent"
                    />
                  </div>

                  {/* Doctor suggestions based on specialty */}
                  {referral.specialty &&
                    specialistDoctors[referral.specialty] && (
                      <div className="mt-2">
                        <p className="text-xs text-gray-500 mb-1">
                          Available {referral.specialty} specialists:
                        </p>
                        <div className="flex flex-wrap gap-1">
                          {specialistDoctors[referral.specialty].map(
                            (doctor) => (
                              <button
                                key={doctor}
                                type="button"
                                onClick={() =>
                                  updateReferral(
                                    referral.id,
                                    "doctorName",
                                    doctor
                                  )
                                }
                                className="inline-flex items-center px-2 py-1 rounded-md bg-orange-100 text-orange-700 text-xs hover:bg-orange-200 transition-colors"
                              >
                                {doctor}
                              </button>
                            )
                          )}
                        </div>
                      </div>
                    )}
                </div>

                {/* Referral Reason */}
                <div className="mb-3">
                  <label className="block text-xs font-medium text-gray-600 mb-1">
                    Reason for Referral *
                  </label>
                  <input
                    type="text"
                    placeholder="Enter the primary reason for this referral"
                    value={referral.reason}
                    onChange={(e) =>
                      updateReferral(referral.id, "reason", e.target.value)
                    }
                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-transparent mb-2"
                  />

                  {/* Quick reasons based on specialty */}
                  {referral.specialty && commonReasons[referral.specialty] && (
                    <div>
                      <p className="text-xs text-gray-500 mb-1">
                        Common reasons for {referral.specialty}:
                      </p>
                      <div className="flex flex-wrap gap-1">
                        {commonReasons[referral.specialty].map((reason) => (
                          <button
                            key={reason}
                            type="button"
                            onClick={() =>
                              updateReferral(referral.id, "reason", reason)
                            }
                            className="inline-flex items-center px-2 py-1 rounded-md bg-amber-100 text-amber-700 text-xs hover:bg-amber-200 transition-colors"
                          >
                            {reason}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                {/* Clinical Notes */}
                <div className="mb-3">
                  <label className="block text-xs font-medium text-gray-600 mb-1">
                    Additional Notes for Specialist
                  </label>
                  <textarea
                    rows={3}
                    placeholder="Include relevant clinical findings, previous treatments tried, or specific questions for the specialist..."
                    value={referral.notes}
                    onChange={(e) =>
                      updateReferral(referral.id, "notes", e.target.value)
                    }
                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-transparent resize-none"
                  />
                </div>

                {/* Action Buttons */}
                <div className="flex justify-between items-center pt-2 border-t border-orange-200">
                  <div className="flex items-center text-xs text-gray-500">
                    <span className="w-2 h-2 bg-orange-400 rounded-full mr-2"></span>
                    Referral #{index + 1}
                    {referral.specialty && (
                      <span className="ml-2 text-orange-600 font-medium">
                        → {referral.specialty}
                      </span>
                    )}
                  </div>
                  <div className="flex space-x-2">
                    {index === 0 ? (
                      <button
                        onClick={addReferral}
                        type="button"
                        className="inline-flex items-center px-3 py-1 rounded-md bg-green-50 border border-green-200 text-sm text-green-700 hover:bg-green-100 transition-colors"
                      >
                        <Plus className="w-4 h-4 mr-1" />
                        Add Referral
                      </button>
                    ) : (
                      <button
                        onClick={() => removeReferral(referral.id)}
                        type="button"
                        className="inline-flex items-center px-3 py-1 rounded-md bg-red-50 border border-red-200 text-sm text-red-700 hover:bg-red-100 transition-colors"
                      >
                        <Trash2 className="w-4 h-4 mr-1" />
                        Remove
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Quick Add Common Referrals */}
          <div className="bg-orange-50 px-4 py-3 border-t border-orange-200">
            <p className="text-xs font-medium text-gray-600 mb-2">
              Quick Add Common Referrals:
            </p>
            <div className="flex flex-wrap gap-2">
              {[
                { specialty: "Cardiology", reason: "Chest pain evaluation" },
                { specialty: "Dermatology", reason: "Skin lesion assessment" },
                { specialty: "Orthopedics", reason: "Joint pain evaluation" },
                { specialty: "Endocrinology", reason: "Diabetes management" },
              ].map((quickReferral) => (
                <button
                  key={`${quickReferral.specialty}-${quickReferral.reason}`}
                  type="button"
                  onClick={() => {
                    const newReferral = {
                      id: Date.now(),
                      specialty: quickReferral.specialty,
                      doctorName: "",
                      reason: quickReferral.reason,
                      urgency: "Routine",
                      notes: "",
                    };
                    setReferralList((prev) => [...prev, newReferral]);
                  }}
                  className="inline-flex items-center px-3 py-1 rounded-md bg-white border border-orange-300 text-xs text-orange-700 hover:bg-orange-100 transition-colors"
                >
                  + {quickReferral.specialty}: {quickReferral.reason}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Waiting Room Component
  const WaitingRoomPage = ({ onJoin }) => (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="bg-white rounded-xl shadow-lg max-w-md w-full p-8 text-center">
        <div className="mb-6">
          <svg
            className="animate-spin h-16 w-16 text-blue-600 mx-auto"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v8H4z"
            ></path>
          </svg>
        </div>

        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          Preparing consultation
        </h2>

        <p className="text-gray-600 mb-6">
          {selectedAppointment?.patient
            ? `Connecting with ${selectedAppointment?.patient}`
            : "Connecting with patient"}
        </p>

        <div className="space-y-2 mb-6">
          <p className="text-gray-700">
            <span className="font-semibold">Appointment Date&Time: </span>
            {new Date(selectedAppointment?.appointmentDateTime).toLocaleString(
              "en-GB",
              {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              }
            )}{" "}
          </p>
          {/* <p className="text-gray-700">
            <span className="font-semibold">Patient: </span> Ahmed Hassan
            {selectedAppointment?.patient}
          </p> */}
        </div>

        <button
          onClick={onJoin}
          className="bg-green-600 text-white px-6 py-3 rounded-lg flex items-center justify-center mx-auto hover:bg-green-700 transition-colors"
        >
          <Video className="h-6 w-6 mr-2" />
          Start Consultation
        </button>
      </div>
    </div>
  );

  // Video Call Component with Clear Images and AI Insights
  const VideoCallPage = ({ onEndCall }) => {
    const [micOn, setMicOn] = useState(true);
    const [videoOn, setVideoOn] = useState(true);
    const patient = generateRandomPatient(selectedAppointment?.id);
    return (
      <div className="min-h-screen bg-gray-100 p-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl font-semibold mb-6 text-gray-900">
            Video Consultation with {patient?.name}
          </h2>

          <div className="grid lg:grid-cols-3 gap-8">
            {/* Video Section - 2/3 width */}
            <div className="lg:col-span-2">
              {/* Main Video Container with Clear Images */}
              <div className="relative rounded-xl overflow-hidden bg-black h-96 mb-6 shadow-lg">
                <img
                  src={patient?.avatar}
                  alt={patient?.name}
                  className="object-cover w-full h-full"
                  style={{
                    imageRendering: "auto",
                    filter: "contrast(1.1) brightness(1.05)",
                  }}
                />

                {/* Video Controls Overlay */}
                <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex items-center space-x-4 bg-black bg-opacity-70 rounded-full px-6 py-3">
                  <button
                    onClick={() => setMicOn(!micOn)}
                    className={`p-3 rounded-full transition-colors ${
                      micOn
                        ? "bg-blue-600 hover:bg-blue-700"
                        : "bg-red-600 hover:bg-red-700"
                    }`}
                    title={micOn ? "Mute Microphone" : "Unmute Microphone"}
                  >
                    {micOn ? (
                      <Mic className="h-6 w-6 text-white" />
                    ) : (
                      <MicOff className="h-6 w-6 text-white" />
                    )}
                  </button>

                  <button
                    onClick={() => setVideoOn(!videoOn)}
                    className={`p-3 rounded-full transition-colors ${
                      videoOn
                        ? "bg-green-600 hover:bg-green-700"
                        : "bg-red-600 hover:bg-red-700"
                    }`}
                    title={videoOn ? "Turn Off Video" : "Turn On Video"}
                  >
                    {videoOn ? (
                      <Video className="h-6 w-6 text-white" />
                    ) : (
                      <VideoOff className="h-6 w-6 text-white" />
                    )}
                  </button>

                  <button
                    onClick={onEndCall}
                    className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-full font-semibold transition-colors"
                    title="End Call"
                  >
                    End Consultation
                  </button>
                </div>
              </div>

              {/* Local Doctor Video */}
              <div className="flex items-center space-x-4">
                <div className="relative rounded-lg overflow-hidden bg-black w-40 h-28 shadow-md">
                  <img
                    src={doctor.avatar}
                    alt="You"
                    className="object-cover w-full h-full"
                    style={{
                      imageRendering: "auto",
                      filter: "contrast(1.1) brightness(1.05)",
                    }}
                  />
                  <div className="absolute bottom-1 left-1 bg-black bg-opacity-70 text-white px-2 py-1 text-xs rounded">
                    You ({doctor.name.split(" ")[1]})
                  </div>
                </div>
                <div>
                  <p className="text-gray-700 font-medium">
                    Consultation in progress
                  </p>
                  <p className="text-gray-500 text-sm">
                    Patient: {patient?.name}
                  </p>
                </div>
              </div>
            </div>

            {/* AI Insights Sidebar - 1/3 width */}
            <div className="lg:col-span-1">
              <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6 h-fit sticky top-6">
                <div className="flex items-center mb-4">
                  <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center mr-3">
                    <Brain className="h-4 w-4 text-teal-600" />
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900">
                    AI Insights
                  </h3>
                </div>

                {/* AI Initial Diagnosis */}
                <div className="mb-6">
                  <h4 className="text-sm font-semibold text-gray-700 mb-3">
                    Initial AI Analysis
                  </h4>
                  <div className="bg-gradient-to-r from-teal-50 to-blue-50 p-4 rounded-lg border border-teal-100">
                    <p className="text-gray-700 text-sm leading-relaxed">
                      {(() => {
                        const text =
                          AppointmentDetails?.aiGeneratedSummary || "";
                        if (!text.trim())
                          return (
                            <p className="text-gray-500">
                              No AI summary available
                            </p>
                          );

                        // Helper function to detect if a line is a header/section title
                        const isHeader = (line) => {
                          const headerPatterns = [
                            /^(Symptoms?|Clinical|Possible|Triggers?|Associated|Differential|Recommendations?|Key points?):/i,
                            /^(Symptoms?|Clinical|Possible|Triggers?|Associated|Differential|Recommendations?)$/i,
                          ];
                          return headerPatterns.some((pattern) =>
                            pattern.test(line.trim())
                          );
                        };

                        // Helper function to detect if a line is a bullet point
                        const isBulletPoint = (line) => {
                          return (
                            /^[\s]*[•\-\*]\s/.test(line) ||
                            /^[\s]*\d+\)\s/.test(line)
                          );
                        };

                        // Check if text contains bullet points within paragraphs
                        const hasBulletsInText =
                          text.includes("•") ||
                          text.includes("*") ||
                          text.includes("-");

                        // Split text into lines and process
                        const lines = text
                          .split(/\r?\n/)
                          .map((line) => line.trim())
                          .filter(Boolean);

                        // Find disclaimer
                        const disclaimerIndex = lines.findIndex(
                          (line) =>
                            line
                              .toLowerCase()
                              .includes("ai-generated summary") ||
                            line
                              .toLowerCase()
                              .includes("clinical reference only") ||
                            line
                              .toLowerCase()
                              .includes("final assessment must be made")
                        );
                        let disclaimer = "";
                        let contentLines = lines;

                        if (disclaimerIndex !== -1) {
                          disclaimer = lines.slice(disclaimerIndex).join(" ");
                          contentLines = lines.slice(0, disclaimerIndex);
                        }

                        // Check if this is a simple paragraph format (no headers, just text with maybe bullets)
                        const hasStructuredContent = contentLines.some(
                          (line) => isHeader(line) || isBulletPoint(line)
                        );

                        // If it's a simple paragraph with bullets, handle it specially
                        if (!hasStructuredContent && hasBulletsInText) {
                          const fullText = contentLines.join(" ");

                          // Split on bullet points and clean up
                          const parts = fullText
                            .split(/[•\*\-]\s+/)
                            .map((part) => part.trim())
                            .filter(Boolean);

                          if (parts.length > 1) {
                            const introText = parts[0];
                            const bulletPoints = parts.slice(1);

                            return (
                              <div className="text-gray-700 leading-relaxed space-y-4">
                                {/* Intro paragraph with NORMAL text size */}
                                {introText && (
                                  <p className="text-base">{introText}</p>
                                )}

                                {/* Bullet points */}
                                <ul className="list-disc list-inside space-y-2 ml-4">
                                  {bulletPoints.map((point, idx) => (
                                    <li key={idx} className="text-base">
                                      {point}
                                    </li>
                                  ))}
                                </ul>

                                {disclaimer && (
                                  <div className="pt-3 border-t border-teal-200">
                                    <p className="text-sm italic text-gray-500">
                                      {disclaimer}
                                    </p>
                                  </div>
                                )}
                              </div>
                            );
                          }
                        }
                        // If it's just a simple paragraph without bullets, render normally
                        if (!hasStructuredContent) {
                          // If no content lines, show only disclaimer
                          if (contentLines.length === 0) {
                            return (
                              <div className="text-gray-700 leading-relaxed space-y-4">
                                {disclaimer && (
                                  <p className="text-lg italic text-gray-500">
                                    {disclaimer}
                                  </p>
                                )}
                              </div>
                            );
                          }

                          // If only 1 line, show entire message as single paragraph
                          if (contentLines.length === 1) {
                            return (
                              <div className="text-gray-700 leading-relaxed space-y-4">
                                <p className="text-base">{contentLines[0]}</p>

                                {disclaimer && (
                                  <div className="pt-3 border-t border-teal-200">
                                    <p className="text-base italic text-gray-500">
                                      {disclaimer}
                                    </p>
                                  </div>
                                )}
                              </div>
                            );
                          }

                          // If multiple lines, show each line as separate paragraph
                          return (
                            <div className="text-gray-700 leading-relaxed space-y-4">
                              {contentLines.map((line, idx) => (
                                <p key={idx} className="text-base">
                                  {line}
                                </p>
                              ))}

                              {disclaimer && (
                                <div className="pt-3 border-t border-teal-200">
                                  <p className="text-base italic text-gray-500">
                                    {disclaimer}
                                  </p>
                                </div>
                              )}
                            </div>
                          );
                        }

                        // Original structured parsing for complex formats
                        const sections = [];
                        let currentSection = { type: "paragraph", content: [] };

                        contentLines.forEach((line, index) => {
                          if (isHeader(line)) {
                            if (currentSection.content.length > 0) {
                              sections.push(currentSection);
                            }
                            currentSection = {
                              type: "section",
                              header: line.replace(/:$/, ""),
                              content: [],
                            };
                          } else if (isBulletPoint(line)) {
                            if (currentSection.type !== "list") {
                              if (currentSection.content.length > 0) {
                                sections.push(currentSection);
                              }
                              currentSection = { type: "list", content: [] };
                            }

                            const cleanedPoint = line
                              .replace(/^[\s]*[•\-\*]\s*/, "")
                              .replace(/^[\s]*\d+\)\s*/, "");
                            currentSection.content.push(cleanedPoint);
                          } else if (line.includes(":") && !isHeader(line)) {
                            if (currentSection.type !== "keyvalue") {
                              if (currentSection.content.length > 0) {
                                sections.push(currentSection);
                              }
                              currentSection = {
                                type: "keyvalue",
                                content: [],
                              };
                            }
                            currentSection.content.push(line);
                          } else {
                            if (currentSection.type === "paragraph") {
                              currentSection.content.push(line);
                            } else {
                              if (currentSection.content.length > 0) {
                                sections.push(currentSection);
                              }
                              currentSection = {
                                type: "paragraph",
                                content: [line],
                              };
                            }
                          }
                        });

                        if (currentSection.content.length > 0) {
                          sections.push(currentSection);
                        }

                        return (
                          <div className="text-gray-700 leading-relaxed space-y-4">
                            {sections.map((section, idx) => {
                              switch (section.type) {
                                case "paragraph":
                                  return (
                                    <div key={idx} className="space-y-2">
                                      {section.content.map(
                                        (paragraph, pIdx) => (
                                          <p key={pIdx} className="text-base">
                                            {paragraph}
                                          </p>
                                        )
                                      )}
                                    </div>
                                  );

                                case "section":
                                  return (
                                    <div key={idx} className="space-y-2">
                                      <h4 className="font-semibold text-gray-800 border-l-4 border-teal-500 pl-3 text-base">
                                        {section.header}
                                      </h4>
                                      <div className="ml-4">
                                        {section.content.map((item, iIdx) => (
                                          <p key={iIdx} className="text-base">
                                            {item}
                                          </p>
                                        ))}
                                      </div>
                                    </div>
                                  );

                                case "list":
                                  return (
                                    <ul
                                      key={idx}
                                      className="list-disc list-inside space-y-2 ml-4"
                                    >
                                      {section.content.map((item, iIdx) => {
                                        const keyValueMatch =
                                          item.match(/^([^:]+):\s*(.*)$/);
                                        if (keyValueMatch) {
                                          return (
                                            <li
                                              key={iIdx}
                                              className="text-base"
                                            >
                                              <span className="font-medium">
                                                {keyValueMatch[1]}:
                                              </span>
                                              <span className="ml-1">
                                                {keyValueMatch[2]}
                                              </span>
                                            </li>
                                          );
                                        }
                                        return (
                                          <li key={iIdx} className="text-base">
                                            {item}
                                          </li>
                                        );
                                      })}
                                    </ul>
                                  );

                                case "keyvalue":
                                  return (
                                    <div
                                      key={idx}
                                      className="space-y-2 bg-gray-50 p-4 rounded"
                                    >
                                      {section.content.map((item, iIdx) => {
                                        const keyValueMatch =
                                          item.match(/^([^:]+):\s*(.*)$/);
                                        if (keyValueMatch) {
                                          return (
                                            <div key={iIdx} className="flex">
                                              <span className="font-medium text-gray-800 min-w-fit mr-2 text-base">
                                                {keyValueMatch[1]}:
                                              </span>
                                              <span className="text-base">
                                                {keyValueMatch[2]}
                                              </span>
                                            </div>
                                          );
                                        }
                                        return (
                                          <p key={iIdx} className="text-base">
                                            {item}
                                          </p>
                                        );
                                      })}
                                    </div>
                                  );

                                default:
                                  return null;
                              }
                            })}

                            {disclaimer && (
                              <div className="pt-4 border-t border-teal-200">
                                <p className="text-sm italic text-gray-500">
                                  {disclaimer}
                                </p>
                              </div>
                            )}
                          </div>
                        );
                      })()}
                    </p>
                  </div>
                </div>

                {/* Suggested Questions */}
                <div className="mb-6">
                  <div className="flex items-center mb-3">
                    <Lightbulb className="h-4 w-4 text-yellow-500 mr-2" />
                    <h4 className="text-sm font-semibold text-gray-700">
                      Suggested Questions
                    </h4>
                  </div>
                  <div className="space-y-2">
                    {[
                      "When did your symptoms first start?",
                      "Rate your discomfort level (1-10)?",
                      "Any medications taken recently?",
                      "Recent travel or allergen exposure?",
                      "Any other accompanying symptoms?",
                      "Family history of similar conditions?",
                    ].map((question, index) => (
                      <div
                        key={index}
                        className="text-sm text-gray-600 p-2 bg-gray-50 rounded border hover:bg-gray-100 cursor-pointer transition-colors"
                      >
                        • {question}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Patient Details Quick View */}
                <div>
                  <h4 className="text-sm font-semibold text-gray-700 mb-3">
                    Patient Info
                  </h4>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-gray-500">Age:</span>
                      <span className="text-gray-900">29</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-500">Sex:</span>
                      <span className="text-gray-900">Male</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-500">Date&Time:</span>
                      <span className="text-gray-900">
                        {new Date(
                          selectedAppointment?.appointmentDateTime
                        ).toLocaleString("en-GB", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })}{" "}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Call Ended Component
  const CallEndedPage = ({ onClose }) => (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="bg-white rounded-xl shadow-lg max-w-md w-full text-center p-8">
        <div className="mb-6">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Check className="h-8 w-8 text-green-600" />
          </div>
        </div>

        <h2 className="text-2xl font-semibold text-gray-900 mb-4">
          Consultation Completed
        </h2>
        <p className="text-gray-600 mb-8">
          Your consultation with {selectedAppointment?.patient} has ended
          successfully. Don't forget to add your notes and prescription.
        </p>

        <div className="space-y-3">
          <button
            onClick={() => {
              setCallEnded(false);
              setSelectedAppointment(selectedAppointment);
              setCurrentPage("appointmentDetails");
            }}
            className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg hover:bg-blue-700 transition-colors font-medium"
          >
            Add Notes & Prescription
          </button>
          <button
            onClick={onClose}
            className="w-full bg-gray-100 text-gray-700 py-3 px-6 rounded-lg hover:bg-gray-200 transition-colors font-medium"
          >
            Return to Appointments
          </button>
        </div>
      </div>
    </div>
  );

  /* -------------------------------------------------------------------- */
  /*  ⬤  AI DIAGNOSIS COMPONENT (NEW)                                     */
  /* -------------------------------------------------------------------- */
  const AIInitialDiagnosisSection = () => {
    return (
      <div className="bg-gradient-to-br from-teal-50 to-blue-50 rounded-xl p-6 border border-teal-200 shadow-sm mb-6">
        <div className="flex items-center mb-4">
          <div className="w-10 h-10 bg-gradient-to-r from-teal-500 to-blue-500 rounded-full flex items-center justify-center mr-4">
            <Brain className="h-6 w-6 text-white" />
          </div>
          <div>
            <h3 className="text-xl font-semibold text-gray-900">
              AI Initial Analysis
            </h3>
            <p className="text-sm text-gray-600">
              Generated based on patient's initial consultation data
            </p>
          </div>
        </div>

        <div className="bg-white p-5 rounded-lg border border-teal-100 shadow-sm">
          <div className="text-gray-700 leading-relaxed">
            {(() => {
              const text = AppointmentDetails?.aiGeneratedSummary || "";
              if (!text.trim())
                return (
                  <p className="text-gray-500 text-center py-4">
                    No AI summary available for this appointment
                  </p>
                );

              // Helper function to detect if a line is a header/section title
              const isHeader = (line) => {
                const headerPatterns = [
                  /^(Symptoms?|Clinical|Possible|Triggers?|Associated|Differential|Recommendations?|Key points?):/i,
                  /^(Symptoms?|Clinical|Possible|Triggers?|Associated|Differential|Recommendations?)$/i,
                ];
                return headerPatterns.some((pattern) =>
                  pattern.test(line.trim())
                );
              };

              // Helper function to detect if a line is a bullet point
              const isBulletPoint = (line) => {
                return (
                  /^[\s]*[•\-\*]\s/.test(line) || /^[\s]*\d+\)\s/.test(line)
                );
              };

              // Check if text contains bullet points within paragraphs
              const hasBulletsInText =
                text.includes("•") || text.includes("*") || text.includes("-");

              // Split text into lines and process
              const lines = text
                .split(/\r?\n/)
                .map((line) => line.trim())
                .filter(Boolean);

              // Find disclaimer
              const disclaimerIndex = lines.findIndex(
                (line) =>
                  line.toLowerCase().includes("ai-generated summary") ||
                  line.toLowerCase().includes("clinical reference only") ||
                  line.toLowerCase().includes("final assessment must be made")
              );
              let disclaimer = "";
              let contentLines = lines;

              if (disclaimerIndex !== -1) {
                disclaimer = lines.slice(disclaimerIndex).join(" ");
                contentLines = lines.slice(0, disclaimerIndex);
              }

              // Check if this is a simple paragraph format (no headers, just text with maybe bullets)
              const hasStructuredContent = contentLines.some(
                (line) => isHeader(line) || isBulletPoint(line)
              );

              // If it's a simple paragraph with bullets, handle it specially
              if (!hasStructuredContent && hasBulletsInText) {
                const fullText = contentLines.join(" ");

                // Split on bullet points and clean up
                const parts = fullText
                  .split(/[•\*\-]\s+/)
                  .map((part) => part.trim())
                  .filter(Boolean);

                if (parts.length > 1) {
                  const introText = parts[0];
                  const bulletPoints = parts.slice(1);

                  return (
                    <div className="space-y-4">
                      {/* Intro paragraph */}
                      {introText && (
                        <p className="text-base leading-relaxed">{introText}</p>
                      )}

                      {/* Bullet points */}
                      <ul className="list-disc list-inside space-y-2 ml-4">
                        {bulletPoints.map((point, idx) => (
                          <li key={idx} className="text-base leading-relaxed">
                            {point}
                          </li>
                        ))}
                      </ul>

                      {disclaimer && (
                        <div className="pt-4 border-t border-teal-200">
                          <p className="text-sm italic text-gray-500">
                            {disclaimer}
                          </p>
                        </div>
                      )}
                    </div>
                  );
                }
              }

              // If it's just a simple paragraph without bullets, render normally
              if (!hasStructuredContent) {
                // If no content lines, show only disclaimer
                if (contentLines.length === 0) {
                  return (
                    <div className="space-y-4">
                      {disclaimer && (
                        <p className="text-base italic text-gray-500">
                          {disclaimer}
                        </p>
                      )}
                    </div>
                  );
                }

                // If only 1 line, show entire message as single paragraph
                if (contentLines.length === 1) {
                  return (
                    <div className="space-y-4">
                      <p className="text-base leading-relaxed">
                        {contentLines[0]}
                      </p>

                      {disclaimer && (
                        <div className="pt-4 border-t border-teal-200">
                          <p className="text-sm italic text-gray-500">
                            {disclaimer}
                          </p>
                        </div>
                      )}
                    </div>
                  );
                }

                // If multiple lines, show each line as separate paragraph
                return (
                  <div className="space-y-4">
                    {contentLines.map((line, idx) => (
                      <p key={idx} className="text-base leading-relaxed">
                        {line}
                      </p>
                    ))}

                    {disclaimer && (
                      <div className="pt-4 border-t border-teal-200">
                        <p className="text-sm italic text-gray-500">
                          {disclaimer}
                        </p>
                      </div>
                    )}
                  </div>
                );
              }

              // Original structured parsing for complex formats
              const sections = [];
              let currentSection = { type: "paragraph", content: [] };

              contentLines.forEach((line, index) => {
                if (isHeader(line)) {
                  if (currentSection.content.length > 0) {
                    sections.push(currentSection);
                  }
                  currentSection = {
                    type: "section",
                    header: line.replace(/:$/, ""),
                    content: [],
                  };
                } else if (isBulletPoint(line)) {
                  if (currentSection.type !== "list") {
                    if (currentSection.content.length > 0) {
                      sections.push(currentSection);
                    }
                    currentSection = { type: "list", content: [] };
                  }

                  const cleanedPoint = line
                    .replace(/^[\s]*[•\-\*]\s*/, "")
                    .replace(/^[\s]*\d+\)\s*/, "");
                  currentSection.content.push(cleanedPoint);
                } else if (line.includes(":") && !isHeader(line)) {
                  if (currentSection.type !== "keyvalue") {
                    if (currentSection.content.length > 0) {
                      sections.push(currentSection);
                    }
                    currentSection = { type: "keyvalue", content: [] };
                  }
                  currentSection.content.push(line);
                } else {
                  if (currentSection.type === "paragraph") {
                    currentSection.content.push(line);
                  } else {
                    if (currentSection.content.length > 0) {
                      sections.push(currentSection);
                    }
                    currentSection = {
                      type: "paragraph",
                      content: [line],
                    };
                  }
                }
              });

              if (currentSection.content.length > 0) {
                sections.push(currentSection);
              }

              return (
                <div className="space-y-4">
                  {sections.map((section, idx) => {
                    switch (section.type) {
                      case "paragraph":
                        return (
                          <div key={idx} className="space-y-2">
                            {section.content.map((paragraph, pIdx) => (
                              <p
                                key={pIdx}
                                className="text-base leading-relaxed"
                              >
                                {paragraph}
                              </p>
                            ))}
                          </div>
                        );

                      case "section":
                        return (
                          <div key={idx} className="space-y-2">
                            <h4 className="font-semibold text-gray-800 border-l-4 border-teal-500 pl-3 text-base">
                              {section.header}
                            </h4>
                            <div className="ml-4 space-y-1">
                              {section.content.map((item, iIdx) => (
                                <p
                                  key={iIdx}
                                  className="text-base leading-relaxed"
                                >
                                  {item}
                                </p>
                              ))}
                            </div>
                          </div>
                        );

                      case "list":
                        return (
                          <ul
                            key={idx}
                            className="list-disc list-inside space-y-2 ml-4"
                          >
                            {section.content.map((item, iIdx) => {
                              const keyValueMatch =
                                item.match(/^([^:]+):\s*(.*)$/);
                              if (keyValueMatch) {
                                return (
                                  <li
                                    key={iIdx}
                                    className="text-base leading-relaxed"
                                  >
                                    <span className="font-medium">
                                      {keyValueMatch[1]}:
                                    </span>
                                    <span className="ml-1">
                                      {keyValueMatch[2]}
                                    </span>
                                  </li>
                                );
                              }
                              return (
                                <li
                                  key={iIdx}
                                  className="text-base leading-relaxed"
                                >
                                  {item}
                                </li>
                              );
                            })}
                          </ul>
                        );

                      case "keyvalue":
                        return (
                          <div
                            key={idx}
                            className="space-y-2 bg-gray-50 p-4 rounded-lg border border-gray-100"
                          >
                            {section.content.map((item, iIdx) => {
                              const keyValueMatch =
                                item.match(/^([^:]+):\s*(.*)$/);
                              if (keyValueMatch) {
                                return (
                                  <div key={iIdx} className="flex">
                                    <span className="font-medium text-gray-800 min-w-fit mr-2 text-base">
                                      {keyValueMatch[1]}:
                                    </span>
                                    <span className="text-base">
                                      {keyValueMatch[2]}
                                    </span>
                                  </div>
                                );
                              }
                              return (
                                <p
                                  key={iIdx}
                                  className="text-base leading-relaxed"
                                >
                                  {item}
                                </p>
                              );
                            })}
                          </div>
                        );

                      default:
                        return null;
                    }
                  })}

                  {disclaimer && (
                    <div className="pt-4 border-t border-teal-200">
                      <p className="text-sm italic text-gray-500">
                        {disclaimer}
                      </p>
                    </div>
                  )}
                </div>
              );
            })()}
          </div>
        </div>

        {/* AI Insights Footer */}
        <div className="mt-4 flex items-center justify-between text-sm">
          <div className="flex items-center text-teal-600">
            <Lightbulb className="h-4 w-4 mr-2" />
            <span>
              Use this analysis as a reference for your clinical assessment
            </span>
          </div>
        </div>
      </div>
    );
  };

  /* -------------------------------------------------------------------- */
  /*  ⬤  NEW PROFILE PAGE COMPONENT                                      */
  /* -------------------------------------------------------------------- */
  const ProfilePage = () => {
    // Mock doctor profile data
    const mockDoctor = {
      name: "Dr. Emily Chen",
      email: "emily.chen@quantumcare.com",
      phone: "+960 112 3344",
      specialty: "General Practice",
      licenseNumber: "MED-2018-001234",
      qualification: "MBBS, MD General Medicine",
      experience: "10+ years",
      bio: "Dedicated healthcare professional with over 10 years of experience in general practice. Specialized in preventive care, chronic disease management, and patient-centered healthcare delivery.",
      avatar: doctor.avatar,
      workingHours: "Monday - Friday: 9:00 AM - 5:00 PM",
    };

    return (
      <div className="min-h-screen bg-gray-50">
        <Navigation />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">
            Profile & Settings
          </h1>

          <div className="grid md:grid-cols-3 gap-8">
            {/* Profile Info */}
            <div className="md:col-span-2 space-y-6">
              {/* Personal Information */}
              <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-xl font-semibold text-gray-900">
                    Personal Information
                  </h2>
                  <button className="flex items-center text-teal-600 hover:text-teal-700">
                    <Camera className="h-4 w-4 mr-1" />
                    Change Photo
                  </button>
                </div>

                <div className="flex items-center space-x-6 mb-6">
                  <img
                    src={mockDoctor.avatar}
                    alt={mockDoctor.name}
                    className="h-24 w-24 rounded-full object-cover border-4 border-gray-100"
                  />
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900">
                      {mockDoctor.name}
                    </h3>
                    <p className="text-teal-600 font-medium">
                      {mockDoctor.specialty}
                    </p>
                    <p className="text-sm text-gray-500 mt-1">
                      {mockDoctor.qualification}
                    </p>
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Full Name
                    </label>
                    <input
                      type="text"
                      defaultValue={mockDoctor.name}
                      className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-teal-400"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Email Address
                    </label>
                    <input
                      type="email"
                      defaultValue={mockDoctor.email}
                      className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-teal-400"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Phone Number
                    </label>
                    <input
                      type="tel"
                      defaultValue={mockDoctor.phone}
                      className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-teal-400"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Medical License
                    </label>
                    <input
                      type="text"
                      defaultValue={mockDoctor.licenseNumber}
                      className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-teal-400"
                    />
                  </div>
                </div>

                <div className="mt-6">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Professional Bio
                  </label>
                  <textarea
                    rows={4}
                    defaultValue={mockDoctor.bio}
                    className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-teal-400 resize-none"
                    placeholder="Tell patients about your experience and specializations..."
                  />
                </div>

                <button className="mt-6 px-6 py-3 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors font-medium">
                  Save Changes
                </button>
              </div>

              {/* Professional Information */}
              <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
                <h2 className="text-xl font-semibold text-gray-900 mb-6">
                  Professional Information
                </h2>

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Specialty
                    </label>
                    <select className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-teal-400">
                      <option>General Practice</option>
                      <option>Internal Medicine</option>
                      <option>Cardiology</option>
                      <option>Dermatology</option>
                      <option>Psychiatry</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Experience
                    </label>
                    <input
                      type="text"
                      defaultValue={mockDoctor.experience}
                      className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-teal-400"
                    />
                  </div>
                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Working Hours
                    </label>
                    <input
                      type="text"
                      defaultValue={mockDoctor.workingHours}
                      className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-teal-400"
                    />
                  </div>
                </div>

                <button className="mt-6 px-6 py-3 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors font-medium">
                  Update Professional Info
                </button>
              </div>
            </div>

            {/* Settings Sidebar */}
            <div className="space-y-6">
              {/* Quick Stats */}
              <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">
                  Quick Stats
                </h3>
                <div className="space-y-4">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <Calendar className="h-5 w-5 text-blue-500 mr-3" />
                      <span className="text-gray-700">This Month</span>
                    </div>
                    <span className="font-semibold text-gray-900">
                      24 consultations
                    </span>
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <Users className="h-5 w-5 text-green-500 mr-3" />
                      <span className="text-gray-700">Total Patients</span>
                    </div>
                    <span className="font-semibold text-gray-900">156</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <Award className="h-5 w-5 text-yellow-500 mr-3" />
                      <span className="text-gray-700">Rating</span>
                    </div>
                    <span className="font-semibold text-gray-900">4.9/5</span>
                  </div>
                </div>
              </div>

              {/* Contact Information */}
              <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">
                  Contact Info
                </h3>
                <div className="space-y-3">
                  <div className="flex items-center">
                    <Mail className="h-4 w-4 text-gray-400 mr-3" />
                    <span className="text-gray-700 text-sm">
                      {mockDoctor.email}
                    </span>
                  </div>
                  <div className="flex items-center">
                    <PhoneIcon className="h-4 w-4 text-gray-400 mr-3" />
                    <span className="text-gray-700 text-sm">
                      {mockDoctor.phone}
                    </span>
                  </div>
                </div>
              </div>

              {/* Security Settings */}
              <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">
                  Security & Privacy
                </h3>
                <div className="space-y-3">
                  <button className="w-full text-left p-3 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors flex items-center">
                    <Shield className="h-4 w-4 mr-3" />
                    Change Password
                  </button>
                  <button className="w-full text-left p-3 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors flex items-center">
                    <Settings className="h-4 w-4 mr-3" />
                    Privacy Settings
                  </button>
                  <button className="w-full text-left p-3 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors flex items-center">
                    <Bell className="h-4 w-4 mr-3" />
                    Notification Preferences
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  /* -------------------------------------------------------------------- */
  /*  ⬤  MAIN COMPONENTS                                                  */
  /* -------------------------------------------------------------------- */

  // Navigation Component (updated to handle Profile click)
  const Navigation = () => (
    <nav className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <img src={quantumLogo} style={{ width: "200px" }} />
            <div className="hidden md:flex ml-10 space-x-4">
              {["home", "appointments"].map((page) => (
                <button
                  key={page}
                  onClick={() => setCurrentPage(page)}
                  className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                    currentPage === page
                      ? "bg-gray-100 text-gray-900"
                      : "text-gray-600 hover:text-gray-900 hover:bg-gray-100"
                  }`}
                >
                  {page.charAt(0).toUpperCase() + page.slice(1)}
                </button>
              ))}
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <div className="w-32">
              <Select
                value={language}
                onValueChange={(value) => setLanguage(value)}
              >
                <SelectTrigger>
                  <SelectValue placeholder="Select language" />
                </SelectTrigger>
                <SelectContent className="w-32 bg-white">
                  <SelectItem value="en-US">English</SelectItem>
                  <SelectItem value="dh-ML">ދިވެހި</SelectItem>
                  <SelectItem value="si-SI">සිංහල</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <button className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 relative">
              <Bell className="h-5 w-5" />
              <span className="absolute -top-1 -right-1 h-3 w-3 bg-red-500 rounded-full" />
            </button>

            <div className="relative">
              <button
                onClick={() => setUserDropdownOpen(!userDropdownOpen)}
                className="flex items-center space-x-3 p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors"
              >
                <img
                  src={doctor.avatar}
                  alt={doctor.name}
                  className="h-10 w-10 rounded-md object-cover"
                />
                <div className="hidden md:block text-left">
                  <p className="text-sm font-medium text-gray-900 leading-none">
                    {doctor.name}
                  </p>
                  <p className="text-xs text-gray-500 leading-none mt-1">
                    {doctor.specialty}
                  </p>
                </div>
                <ChevronDown className="h-4 w-4" />
              </button>

              {userDropdownOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-100 rounded-md shadow-lg py-1 z-50">
                  <button
                    onClick={() => {
                      setCurrentPage("profile");
                      setUserDropdownOpen(false);
                    }}
                    className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >
                    <User className="h-4 w-4 mr-3" />
                    Profile
                  </button>
                  <button className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                    <Settings className="h-4 w-4 mr-3" />
                    Settings
                  </button>
                  {/* <hr className="my-1" />
                   <button
                    onClick={() => {
                      Navigate("/dashboardwhite");
                    }}
                    className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
                  >
                    <ArrowRight className="mr-3 h-4 w-4" />
                    Patient Dashboard
                  </button>
                  <button
                    onClick={() => {
                      Navigate("/nursedashboard");
                    }}
                    className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
                  >
                    <ArrowRight className="mr-3 h-4 w-4" />
                    Nurse Dashboard
                  </button> */}
                  <hr className="my-1" />
                  <button
                    className="flex items-center w-full px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
                    onClick={() => {
                      Navigate("/");
                    }}
                  >
                    <LogOut className="h-4 w-4 mr-3" />
                    Log out
                  </button>
                </div>
              )}
            </div>

            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100"
            >
              {isMobileMenuOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden border-t border-gray-200 bg-gray-50">
          <div className="px-2 pt-2 pb-3 space-y-1">
            {["home", "appointments"].map((page) => (
              <button
                key={page}
                onClick={() => {
                  setCurrentPage(page);
                  setIsMobileMenuOpen(false);
                }}
                className="block w-full text-left px-3 py-2 rounded-md text-base font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100"
              >
                {page.charAt(0).toUpperCase() + page.slice(1)}
              </button>
            ))}
          </div>
        </div>
      )}
    </nav>
  );

  // Home Page Component
  const HomePage = () => {
    const upcoming = allAppointments
      .filter((a) => a.status === "Upcoming")
      .slice(0, 3);

    const recent = allAppointments
      .filter((a) => a.status !== "Upcoming")
      .slice(0, 3);

    return (
      <div className="min-h-screen bg-gray-50">
        <Navigation />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">
            {<FormattedMessage id="DoctorDashboard.Goodafternoon" />},{" "}
            <span className="text-teal-700">{doctor.name.split(" ")[1]}</span>
          </h1>

          <div className="grid lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2 space-y-6">
              <div className="bg-white rounded-xl border border-gray-200 shadow-sm">
                <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
                  <h2 className="text-lg font-semibold text-gray-900">
                    {
                      <FormattedMessage id="DoctorDashboard.UpcomingAppointments" />
                    }
                  </h2>
                  <button
                    onClick={() => setCurrentPage("appointments")}
                    className="text-sm text-blue-600 hover:underline"
                  >
                    {<FormattedMessage id="DoctorDashboard.Viewall" />}
                  </button>
                </div>
                <div className="divide-y divide-gray-200">
                  {upcoming.length === 0 && (
                    <p className="p-6 text-gray-500">
                      {
                        <FormattedMessage id="DoctorDashboard.Noupcomingappointments" />
                      }
                    </p>
                  )}
                  {upcoming.map((apt) => {
                    const patient = generateRandomPatient(apt?.id);
                    return (
                      <div
                        key={apt.id}
                        className="p-6 flex items-center justify-between"
                      >
                        <div className="flex items-center space-x-4">
                          <img
                            src={patient?.avatar}
                            alt={patient?.name}
                            className="h-10 w-10 rounded-full object-cover"
                          />
                          <div>
                            <p className="text-gray-900 font-medium">
                              {patient?.name} | {patient?.cardno}
                            </p>
                            <p className="text-sm text-gray-600">
                              {new Date(
                                apt?.appointmentDateTime
                              ).toLocaleDateString("en-CA")}{" "}
                              •{" "}
                              {new Date(
                                apt.appointmentDateTime
                              ).toLocaleTimeString([], {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              })}
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center space-x-3">
                          <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                            {apt.consultationType === "Video"
                              ? "Video"
                              : "Chat"}
                          </span>
                          {apt.consultationType === "Video" && (
                            <button
                              onClick={() => startVideoCall(apt.id)}
                              className="px-3 py-1 bg-blue-600 text-white rounded text-sm hover:bg-blue-700 transition-colors"
                            >
                              {
                                <FormattedMessage id="PatientAppointment.Join" />
                              }
                            </button>
                          )}
                          <button
                            onClick={() => {
                              // setSelectedAppointment(apt);
                              setCurrentPage("appointmentDetails");
                              callAppointmentDetails(apt.id);
                            }}
                            className="text-blue-600 hover:underline text-sm"
                          >
                            {<FormattedMessage id="DoctorDashboard.View" />}
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            <div className="space-y-6">
              <div className="bg-white rounded-xl border border-gray-200 shadow-sm">
                <h2 className="text-lg font-semibold text-gray-900 px-6 py-4 border-b border-gray-200">
                  {<FormattedMessage id="DoctorDashboard.RecentActivity" />}
                </h2>
                <div className="divide-y divide-gray-200">
                  {recent.map((apt) => (
                    <div
                      key={apt.id}
                      className="px-6 py-4 flex items-center justify-between"
                    >
                      <div>
                        <p className="text-gray-900 font-medium">
                          {apt.doctorName} –{" "}
                          <span className="capitalize">{apt.status}</span>
                        </p>
                        <p className="text-sm text-gray-600">
                          {new Date(
                            apt?.appointmentDateTime
                          ).toLocaleDateString("en-CA")}{" "}
                          •{" "}
                          {new Date(apt.appointmentDateTime).toLocaleTimeString(
                            [],
                            {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            }
                          )}
                        </p>
                      </div>
                      <button
                        onClick={() => {
                          callAppointmentDetails(apt.id);
                          setCurrentPage("appointmentDetails");
                        }}
                      >
                        <ChevronRight className="h-4 w-4 text-gray-400" />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Appointments Page Component
  const AppointmentsPage = () => {
    const filtered =
      filter === "all"
        ? allAppointments
        : allAppointments.filter((a) => a.status === filter);

    return (
      <div className="min-h-screen bg-gray-50">
        <Navigation />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex items-center justify-between mb-8">
            <h1 className="text-3xl font-bold text-gray-900">
              {<FormattedMessage id="PatientDashboard.Appointments" />}
            </h1>
            <div className="flex space-x-3">
              <button className="flex items-center px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300">
                <Search className="h-4 w-4 mr-2" />
                {<FormattedMessage id="Common.Search" />}
              </button>
              <button className="flex items-center px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300">
                <Filter className="h-4 w-4 mr-2" />
                {<FormattedMessage id="Common.Filter" />}
              </button>
            </div>
          </div>

          <div className="flex space-x-4 mb-6 overflow-x-auto">
            {[
              {
                label: <FormattedMessage id="PatientAppointment.All" />,
                value: "all",
              },
              {
                label: <FormattedMessage id="PatientAppointment.Upcoming" />,
                value: "Upcoming",
              },
              {
                label: <FormattedMessage id="PatientAppointment.Completed" />,
                value: "Completed",
              },
            ].map((f) => (
              <button
                key={f.value}
                onClick={() => setFilter(f.value)}
                className={`px-4 py-2 rounded-lg text-sm font-medium ${
                  filter === f.value
                    ? "bg-blue-600 text-white"
                    : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                }`}
              >
                {f.label}
              </button>
            ))}
          </div>

          <div className="bg-white border border-gray-200 rounded-xl shadow-sm divide-y divide-gray-200">
            {filtered.map((apt) => {
              const patient = generateRandomPatient(apt.id);
              return (
                <div
                  key={apt.id}
                  className="flex items-center justify-between p-6"
                >
                  <div className="flex items-center space-x-4">
                    <img
                      src={patient.avatar}
                      alt={patient.name}
                      className="h-12 w-12 rounded-full object-cover"
                    />
                    <div>
                      <p className="font-medium text-gray-900">
                        {patient.name} | {patient.cardno}
                      </p>
                      <p className="text-sm text-gray-600">
                        {new Date(apt?.appointmentDateTime).toLocaleDateString(
                          "en-CA"
                        )}{" "}
                        •{" "}
                        {new Date(apt.appointmentDateTime).toLocaleTimeString(
                          [],
                          {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          }
                        )}
                      </p>
                      {/* <p className="text-xs text-gray-500 mt-1">
                      {apt.doctorNotes}
                    </p> */}
                    </div>
                  </div>

                  <div className="flex items-center space-x-4">
                    {apt.consultationType === "Video" ? (
                      <Video className="h-5 w-5 text-blue-500" />
                    ) : (
                      <MessageCircle className="h-5 w-5 text-green-500" />
                    )}

                    <span
                      className={`px-2 py-1 rounded-full text-xs font-medium capitalize ${
                        apt.status === "Upcoming"
                          ? "bg-green-100 text-green-800"
                          : "bg-blue-100 text-blue-800"
                      }`}
                    >
                      {apt.status}
                    </span>

                    {apt.consultationType === "Video" &&
                      apt.status === "Upcoming" && (
                        <button
                          onClick={() => startVideoCall(apt.id)}
                          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm transition-colors"
                        >
                          {<FormattedMessage id="PatientAppointment.Join" />}
                        </button>
                      )}

                    <button
                      onClick={() => {
                        callAppointmentDetails(apt.id);
                        setCurrentPage("appointmentDetails");
                      }}
                      className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 text-sm"
                    >
                      {<FormattedMessage id="DoctorDashboard.View" />}
                    </button>
                  </div>
                </div>
              );
            })}

            {filtered.length === 0 && (
              <p className="p-6 text-gray-500">No appointments found.</p>
            )}
          </div>
        </div>
      </div>
    );
  };

  // Appointment Details Page Component (UPDATED with new prescription section)
  const AppointmentDetailsPage = () => {
    const [doctorNotes, setDoctorNotes] = useState("");
    if (!selectedAppointment) return null;

    const patient = generateRandomPatient(selectedAppointment?.id);
    // Add this state to your existing state declarations

    const handleSubmit = () => {
      // if (
      //   !doctorNotes.trim() &&
      //   !prescription.trim() &&
      //   !labTests.trim() &&
      //   !referrals.trim()
      // ) {
      //   alert(
      //     "Please add notes, prescription, lab tests, or referrals before saving."
      //   );
      //   return;
      // }

      // Show confirmation modal instead of direct save
      setShowConfirmModal(true);
    };

    const handleConfirmSave = () => {
      // Close confirmation modal
      setShowConfirmModal(false);

      // Simulate saving process
      setTimeout(() => {
        // Clear form data
        setDoctorNotes("");
        setPrescription("");
        setLabTests("");
        setReferrals("");

        // Show success modal
        setShowSuccessModal(true);
      }, 500);
    };

    const handleSuccessClose = () => {
      setShowSuccessModal(false);
      // Optionally navigate back to appointments
      setCurrentPage("appointments");
    };

    // Confirmation Modal Component
    const ConfirmationModal = () => (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 transform transition-all">
          {/* Header */}
          <div className="px-6 py-4 border-b border-gray-100">
            <h3 className="text-xl font-semibold text-gray-900 flex items-center">
              <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                <FileText className="h-4 w-4 text-blue-600" />
              </div>
              Send Prescription
            </h3>
            <p className="text-sm text-gray-600 mt-1">
              Choose where to send the prescription details
            </p>
          </div>

          {/* Body */}
          <div className="px-6 py-6 space-y-4">
            <p className="text-gray-700 mb-4">
              Do you want to send the prescription and appointment details?
            </p>

            {/* Checkboxes */}
            <div className="space-y-3">
              <label className="flex items-center p-3 bg-gray-50 rounded-lg border border-gray-200 hover:bg-gray-100 transition-colors cursor-pointer">
                <input
                  type="checkbox"
                  checked={sendToPharmacy}
                  onChange={(e) => setSendToPharmacy(e.target.checked)}
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
                <div className="ml-3 flex-1">
                  <span className="font-medium text-gray-900">
                    Send to Pharmacy
                  </span>
                  <p className="text-sm text-gray-600">
                    Prescription will be sent to the nearest pharmacy for
                    preparation
                  </p>
                </div>
                <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                  <span className="text-green-600 text-sm">💊</span>
                </div>
              </label>

              <label className="flex items-center p-3 bg-gray-50 rounded-lg border border-gray-200 hover:bg-gray-100 transition-colors cursor-pointer">
                <input
                  type="checkbox"
                  checked={sendToPatient}
                  onChange={(e) => setSendToPatient(e.target.checked)}
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
                <div className="ml-3 flex-1">
                  <span className="font-medium text-gray-900">
                    Send to Patient
                  </span>
                  <p className="text-sm text-gray-600">
                    Patient will receive prescription and care instructions via
                    email/SMS
                  </p>
                </div>
                <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                  <span className="text-blue-600 text-sm">👤</span>
                </div>
              </label>
            </div>
          </div>

          {/* Footer */}
          <div className="px-6 py-4 bg-gray-50 rounded-b-2xl flex space-x-3">
            <button
              onClick={() => setShowConfirmModal(false)}
              className="flex-1 px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors font-medium"
            >
              Cancel
            </button>
            <button
              onClick={handleConfirmSave}
              className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium flex items-center justify-center"
            >
              <Save className="h-4 w-4 mr-2" />
              Save & Send
            </button>
          </div>
        </div>
      </div>
    );

    // Success Modal Component
    const SuccessModal = () => (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm mx-4 transform transition-all">
          {/* Success Icon */}
          <div className="text-center pt-8 pb-4">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4 animate-pulse">
              <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                <Check className="h-6 w-6 text-white" />
              </div>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              Successfully Saved!
            </h3>
            <p className="text-gray-600 text-sm px-4">
              Appointment details have been saved and sent successfully
            </p>
          </div>

          {/* Status Info */}
          <div className="px-6 py-4 space-y-2">
            {sendToPharmacy && (
              <div className="flex items-center text-sm text-green-600 bg-green-50 p-2 rounded-lg">
                <Check className="h-4 w-4 mr-2" />
                <span>Prescription sent to pharmacy</span>
              </div>
            )}
            {sendToPatient && (
              <div className="flex items-center text-sm text-blue-600 bg-blue-50 p-2 rounded-lg">
                <Check className="h-4 w-4 mr-2" />
                <span>Details sent to patient</span>
              </div>
            )}
          </div>

          {/* Footer */}
          <div className="px-6 py-4 bg-gray-50 rounded-b-2xl">
            <button
              onClick={handleSuccessClose}
              className="w-full px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors font-medium"
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    );

    return (
      <div className="min-h-screen bg-gray-50">
        <Navigation />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex items-center justify-between mb-8">
            <div className="flex items-center">
              <button
                onClick={() => setCurrentPage("appointments")}
                className="flex items-center text-gray-600 hover:text-gray-900 mr-4"
              >
                <ArrowLeft className="h-5 w-5 mr-2" />
                Back
              </button>
              <h1 className="text-3xl font-bold text-gray-900">
                {
                  <FormattedMessage id="AppointmentDetails.AppointmentDetails" />
                }
              </h1>
            </div>

            {selectedAppointment.consultationType === "Video" &&
              selectedAppointment.status === "Upcoming" && (
                <button
                  onClick={() => startVideoCall(selectedAppointment.id)}
                  className="flex items-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
                >
                  <Video className="h-5 w-5 mr-2" />
                  {<FormattedMessage id="AppointmentDetails.JoinVideo" />}
                </button>
              )}
          </div>

          <div className="grid lg:grid-cols-3 gap-8">
            <div className="lg:col-span-1 space-y-6">
              <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
                <div className="flex items-center mb-4">
                  <img
                    src={patient?.avatar}
                    alt={patient?.name}
                    className="h-16 w-16 rounded-full object-cover mr-4"
                  />
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900">
                      {patient?.name}
                    </h3>
                    <p className="text-gray-600">
                      {new Date(
                        selectedAppointment?.appointmentDateTime
                      ).toLocaleDateString("en-CA")}{" "}
                      •{" "}
                      {new Date(
                        selectedAppointment.appointmentDateTime
                      ).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })}
                    </p>
                  </div>
                </div>

                <div className="space-y-3">
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-700">Age:</span>
                    <span className="text-gray-900">29</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-700">Sex:</span>
                    <span className="text-gray-900">Male</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-700">Phone:</span>
                    <span className="text-gray-900">+960 123 4567</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-700">Email:</span>
                    <span className="text-gray-900">example.ha@example.mv</span>
                  </div>
                </div>
              </div>

              {/* Vitals Card */}
              <div className="bg-white rounded-2xl p-6 border border-gray-200 shadow-lg max-w-sm mx-auto">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">
                  {<FormattedMessage id="AppointmentDetails.VitalSigns" />}
                </h3>
                <div>
                  {/* Row 1 */}
                  <div className="grid grid-cols-3 gap-4 py-2">
                    <div className="rounded-md bg-gradient-to-br from-green-100 to-green-50 p-3 shadow">
                      <p className="text-sm font-bold text-green-700">120/80</p>
                      <p className="text-xs text-gray-500 mt-1">
                        Blood Pressure
                      </p>
                    </div>
                    <div className="rounded-md bg-gradient-to-br from-blue-100 to-blue-50 p-3 shadow">
                      <p className="text-sm font-bold text-blue-700">98%</p>
                      <p className="text-xs text-gray-500 mt-1">
                        Pulse Oximetry
                      </p>
                    </div>
                    <div className="rounded-md bg-gradient-to-br from-purple-100 to-purple-50 p-3 shadow">
                      <p className="text-sm font-bold text-purple-700">172cm</p>
                      <p className="text-xs text-gray-500 mt-1">Height</p>
                    </div>
                  </div>

                  {/* Row 2 */}
                  <div className="grid grid-cols-3 gap-4 py-2">
                    <div className="rounded-md bg-gradient-to-br from-yellow-100 to-yellow-50 p-3 shadow">
                      <p className="text-sm font-bold text-yellow-700">70kg</p>
                      <p className="text-xs text-gray-500 mt-1">Weight</p>
                    </div>
                    <div className="rounded-md bg-gradient-to-br from-teal-100 to-teal-50 p-3 shadow">
                      <p className="text-sm font-bold text-teal-700">Normal</p>
                      <p className="text-xs text-gray-500 mt-1">Metabolism</p>
                    </div>
                    <div className="rounded-md bg-gradient-to-br from-cyan-100 to-cyan-50 p-3 shadow">
                      <p className="text-sm font-bold text-cyan-700">42L</p>
                      <p className="text-xs text-gray-500 mt-1">Body Water</p>
                    </div>
                  </div>

                  {/* Row 3 */}
                  <div className="grid grid-cols-3 gap-4 py-2">
                    <div className="rounded-md bg-gradient-to-br from-pink-100 to-pink-50 p-3 shadow">
                      <p className="text-sm font-bold text-pink-700">15%</p>
                      <p className="text-xs text-gray-500 mt-1">Body Fat</p>
                    </div>
                    <div className="rounded-md bg-gradient-to-br from-orange-100 to-orange-50 p-3 shadow">
                      <p className="text-sm font-bold text-orange-700">32</p>
                      <p className="text-xs text-gray-500 mt-1">Body Age</p>
                    </div>
                    <div className="rounded-md p-3 shadow bg-gradient-to-br from-green-100 to-green-50 max-w-[120px] break-words">
                      <p className="text-sm font-bold text-green-700 break-words">
                        3.2kg/m²
                      </p>
                      <p className="text-xs text-gray-500 mt-1 break-words">
                        Bone Mass
                      </p>
                    </div>
                  </div>

                  {/* Row 4 */}
                  <div className="grid grid-cols-3 gap-4 py-2">
                    <div className="rounded-md bg-gradient-to-br from-red-100 to-red-50 p-3 shadow">
                      <p className="text-sm font-bold text-red-700">45g</p>
                      <p className="text-xs text-gray-500 mt-1">Protein</p>
                    </div>
                    <div className="rounded-md bg-gradient-to-br from-violet-100 to-violet-50 p-3 shadow">
                      <p className="text-sm font-bold text-violet-700">8.5</p>
                      <p className="text-xs text-gray-500 mt-1">Visceral Fat</p>
                    </div>
                    <div className="rounded-md bg-gradient-to-br from-fuchsia-100 to-fuchsia-50 p-3 shadow">
                      <p className="text-sm font-bold text-fuchsia-700">58kg</p>
                      <p className="text-xs text-gray-500 mt-1">Muscle Mass</p>
                    </div>
                  </div>

                  {/* Row 5 */}
                  <div className="grid grid-cols-3 gap-4 py-2">
                    <div className="rounded-md bg-gradient-to-br from-gray-200 to-gray-100 p-3 shadow">
                      <p className="text-sm font-bold text-gray-700">10.5kg</p>
                      <p className="text-xs text-gray-500 mt-1">LBM</p>
                    </div>
                    <div className="rounded-md bg-gradient-to-br from-gray-300 to-gray-100 p-3 shadow">
                      <p className="text-sm font-bold text-gray-700">Class I</p>
                      <p className="text-xs text-gray-500 mt-1">Obesity</p>
                    </div>
                    <div className="rounded-md bg-gradient-to-br from-gray-400 to-gray-200 p-3 shadow">
                      <p className="text-sm font-bold text-gray-700">23.7</p>
                      <p className="text-xs text-gray-500 mt-1">BMI</p>
                    </div>
                  </div>

                  {/* Row 6 */}
                  <div className="grid grid-cols-3 gap-4 py-2">
                    <div className="rounded-md bg-gradient-to-br from-indigo-100 to-indigo-50 p-3 shadow max-w-[120px] break-words">
                      <p className="text-sm font-bold text-indigo-700 break-words">
                        14.2g/dL
                      </p>
                      <p className="text-xs text-gray-500 mt-1">Hemoglobin</p>
                    </div>
                    <div className="rounded-md bg-gradient-to-br from-sky-100 to-sky-50 p-3 shadow max-w-[120px] break-words">
                      <p className="text-sm font-bold text-sky-700 break-words">
                        95mg/dl
                      </p>
                      <p className="text-xs text-gray-500 mt-1">Blood Sugar</p>
                    </div>
                    <div className="rounded-md bg-gradient-to-br from-amber-100 to-amber-50 p-3 shadow max-w-[120px] break-words">
                      <p className="text-sm font-bold text-amber-700 break-words">
                        180mg/dL
                      </p>
                      <p className="text-xs text-gray-500 mt-1">Cholesterol</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">
                  Appointment Info
                </h3>
                <div className="space-y-2">
                  <div className="flex items-center">
                    {selectedAppointment.consultationType === "Video" ? (
                      <Video className="h-4 w-4 text-blue-500 mr-2" />
                    ) : (
                      <MessageCircle className="h-4 w-4 text-green-500 mr-2" />
                    )}
                    <span className="text-sm capitalize">
                      {selectedAppointment.consultationType} Consultation
                    </span>
                  </div>
                  <div className="flex items-center">
                    <span
                      className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                        selectedAppointment.status === "Upcoming"
                          ? "bg-green-100 text-green-800"
                          : "bg-blue-100 text-blue-800"
                      }`}
                    >
                      {selectedAppointment.status.charAt(0).toUpperCase() +
                        selectedAppointment.status.slice(1)}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="lg:col-span-2">
              {/* AI Summary */}
              <AIInitialDiagnosisSection />
              {/* Doctor's Notes & Prescription Section */}
              <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
                <div className="flex items-center mb-6">
                  <FileText className="h-6 w-6 text-gray-700 mr-3" />
                  <h3 className="text-xl font-semibold text-gray-900">
                    {
                      <FormattedMessage id="AppointmentDetails.Doctor'sNotes&Prescription" />
                    }
                  </h3>
                </div>

                <div className="space-y-6">
                  <div>
                    <label
                      htmlFor="doctorNotes"
                      className="block text-sm font-medium text-gray-700 mb-2"
                    >
                      Doctor's Notes
                    </label>
                    <textarea
                      id="doctorNotes"
                      rows={8}
                      value={doctorNotes}
                      onChange={(e) => setDoctorNotes(e.target.value)}
                      className="w-full border border-gray-300 rounded-lg px-4 py-3 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent resize-none"
                      placeholder="Enter your clinical observations, diagnosis, and treatment recommendations..."
                    />
                  </div>

                  {/* UPDATED: Replace textarea with PrescriptionSection */}
                  <SimplePrescriptionTable
                    rows={prescriptionRows}
                    onFieldChange={handlePrescriptionFieldChange}
                    onAddRow={addPrescriptionRow}
                    onRemoveRow={removePrescriptionRow}
                  />

                  <IntegratedDeviceTestSection
                    recommendedTests={recommendedTests}
                    setRecommendedTests={setRecommendedTests}
                    nearestPHC={nearestPHC}
                    setNearestPHC={setNearestPHC}
                  />

                  <LabTestsSection
                    labTests={labTests}
                    setLabTests={setLabTests}
                  />
                  <ReferralSection
                    referrals={referrals}
                    setReferrals={setReferrals}
                  />
                  <div className="flex justify-end space-x-4 pt-6 border-t border-gray-200">
                    <button
                      onClick={() => setCurrentPage("appointments")}
                      className="px-6 py-3 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors font-medium"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleSubmit}
                      className="flex items-center px-6 py-3 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors font-medium"
                    >
                      <Save className="h-4 w-4 mr-2" />
                      Save Notes & Prescription
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {showConfirmModal && <ConfirmationModal />}
        {showSuccessModal && <SuccessModal />}
      </div>
    );
  };

  // Render Page Logic
  const renderPage = () => {
    if (isInWaitingRoom)
      return <WaitingRoomPage onJoin={handleJoinVideoCall} />;
    if (isOnVideoCall) return <VideoCallPage onEndCall={handleEndCall} />;
    if (callEnded) return <CallEndedPage onClose={handleCallEndedClose} />;

    switch (currentPage) {
      case "home":
        return <HomePage />;
      case "appointments":
        return <AppointmentsPage />;
      case "appointmentDetails":
        return <AppointmentDetailsPage />;
      case "profile":
        return <ProfilePage />;
      default:
        return <HomePage />;
    }
  };

  return <>{renderPage()}</>;
}

export default DoctorDashboard;
